export default __webpack_public_path__ + "static/5G0A8487-12800255dcbf29f6da594c27936336a8.jpg";